var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85857 18.8432C5.72707 19.1698 5.51668 19.3205 5.14848 19.3205H3.7809C3.41271 19.3205 3.30751 19.1698 3.43901 18.8432L9.46162 3.01579C9.59312 2.68919 9.80352 2.53845 10.1717 2.53845H11.8286C12.1968 2.53845 12.4072 2.68919 12.5387 3.01579L18.5613 18.8432C18.6928 19.1698 18.5876 19.3205 18.2194 19.3205H16.8518C16.4836 19.3205 16.2732 19.1698 16.1417 18.8432L14.6952 14.924H7.30505L5.85857 18.8432ZM7.96244 13.0901H14.0114L10.9869 4.82469L7.96244 13.0901Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplay);
export default __webpack_public_path__ + "static/media/Autoplay.02d5b187c4f93bbe49a714debe3943c5.svg";
export { ForwardRef as ReactComponent };